import { computed, Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private amountOfLoaders = signal(0);

  readonly isLoading: Signal<boolean> = computed(
    () => this.amountOfLoaders() > 0,
  );

  public show(): void {
    this.amountOfLoaders.update((value) => value + 1);
  }

  public hide(): void {
    this.amountOfLoaders.update((value) => Math.max(0, value - 1));
  }

  public reset(): void {
    this.amountOfLoaders.set(0);
  }
}
